import { KeyRound } from "lucide-react";
import React from "react";
import { Button, Modal, ModalBody } from "reactstrap";

const UserAlert = ({ message, handelModal, modal }) => {
  const toggle = () => handelModal(!modal);
  return (
    <Modal isOpen={modal} toggle={toggle}>
      <ModalBody className="modal-body-lg text-center">
        <div className="nk-modal">
          <KeyRound size={50} className=" " />
          <h4 className="nk-modal-title">Change Password!</h4>
          <div className="nk-modal-text">
            <div className="caption-text">{message}</div>
          </div>
          <div className="nk-modal-action">
            <Button
              color="primary"
              size="lg"
              className="btn-mw"
              onClick={toggle}
            >
              OK
            </Button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default UserAlert;
